import { useState, useEffect } from "react";
import axios from "axios";

const useBookmakersList = () => {
  const [bookmakers, setBookmakers] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookmakers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://tool.bonusbank.com.au/api/v3/bookmakers/`
        );
        setBookmakers(response.data.bookies);
        setError(null);
      } catch (err) {
        setError(err);
        setBookmakers({});
      } finally {
        setLoading(false);
      }
    };

    fetchBookmakers();
  }, []);

  return { bookmakers, loading, error };
};

export default useBookmakersList;
